export default __webpack_public_path__ + "static/media/kalen-emsley-Bkci_8qcdvQ-unsplash.7babde8d.jpg";